import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { debounce } from 'lodash';
import Auth0 from '../../../../../../../../store/actions/auth/Auth'

export const CLEAR_RECIPIENTS = 'CLEAR_RECIPIENTS';

export const findRecipients = createAsyncThunk(
  'recipients/findRecipients',
  async (searchPhrase) => {
    const response = await axios.get(`api/admin/deliveries/searchActor?searchPhrase=${searchPhrase}`, {
      headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` }
    });
    return response.data;
  }
);

const debouncedFindRecipients = debounce((dispatch, searchPhrase) => {
  dispatch(findRecipients(searchPhrase));
}, 500);

export const actionCreators = {
  findRecipients: (searchPhrase) => (dispatch) => {
    if (searchPhrase.length > 2) {
      debouncedFindRecipients(dispatch, searchPhrase);
    }
    if (searchPhrase === '') {
      dispatch({ type: CLEAR_RECIPIENTS });
    }
  }
};